import { Controller } from "@hotwired/stimulus"

const METADATA_SELECTORS = [
  ".university_sso_provider_metadata",
  ".university_group_sso_provider_metadata"
]

const OPEN_ID_SELECTORS = [
  ".university_sso_provider_client_id",
  ".university_sso_provider_client_secret",
  ".university_sso_provider_oidc_issuer_url",
  ".university_group_sso_provider_client_id",
  ".university_group_sso_provider_client_secret",
  ".university_group_sso_provider_oidc_issuer_url"
]

// SAML-style providers federate through Cognito via metadata. saml/azure are
// selectable everywhere; the rest only in development for the local SSO
// simulator (see SSOProvider::DEVELOPMENT_SSO_PROVIDER_KEYS).
const METADATA_PROVIDER_KEYS = [
  "saml",
  "azure",
  "okta",
  "ldap",
  "google_workspace",
  "shibboleth",
  "ping_federate",
  "adfs"
]

export default class extends Controller {
  static targets = ["ssoProviderInput", "providerSettingsSection", "form"]
  static values = { ssoProvidersMap: Object }

  ELEMENTS_PER_PROVIDER = {
    ...Object.fromEntries(METADATA_PROVIDER_KEYS.map(key => [ key, METADATA_SELECTORS ])),
    "open_id": OPEN_ID_SELECTORS
  }

  connect() {
    this.updateProviderSettingsVisibility(false)
  }

  updateProviderSettingsVisibility(clearInputs = true) {
    this.providerSettingsSectionTarget.classList.toggle("hidden!", this.isSSOProviderBlank())
    this.hideAllControllableInputs()
    if (clearInputs)
      this.clearAllControllableInputs()
    this.showProviderInputs()
  }

  isSSOProviderBlank() {
    return !this.ssoProviderInputTarget.value
  }

  submitForm() {
    this.formTarget.requestSubmit()
  }

  showProviderInputs() {
    if (this.isSSOProviderBlank())
      return

    const provider = this.ssoProvidersMapValue[this.ssoProviderInputTarget.value]
    if (!provider)
      return

    const elementSelectors = this.ELEMENTS_PER_PROVIDER[provider]

    this.getElements(elementSelectors).forEach(element => element.classList.toggle("hidden!", false))
  }

  hideAllControllableInputs() {
    this.getControllableElements().forEach(element => element.classList.toggle("hidden!", true))
  }

  clearAllControllableInputs() {
    this.getControllableElements().forEach(element => element.querySelector("input").value = "")
  }

  getControllableElements() {
    return this.getElements(Object.values(this.ELEMENTS_PER_PROVIDER).flat())
  }

  getElements(selectors) {
    return this.element.querySelectorAll(selectors.join(", "))
  }
}
